import styled from "styled-components";
import { BONUS_IMG, RefreshOutlined, IMG_Wallet } from "@assets";
import { REJECTED_SK, REQUESTED_SK } from "@constants";

export const RootContainer = styled.div`
  position: relative;
  height: 100vh;
  overflow: hidden;
`;

export const RefreshIcon = styled(RefreshOutlined)`
  font-size: 24px;
  color: #fff;
`;

export const ActionButton = styled.div`
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #212224;
  border-radius: 8px;
  cursor: pointer;
  padding: 8px;
`;

export const ActionLabel = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: #f9f9f9;
`;

export const ActionsWrapper = styled.div`
  margin: 8px 16px;
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: center;
`;

export const EmptyText = styled.div`
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  color: #808080;
`;

export const ListContainer = styled.div`
  height: calc(100vh - 270px);
  overflow-y: auto;

  .loader {
    height: calc(100vh - 406px);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .empty-box {
    height: calc(100vh - 406px);
    display: flex;
    flex-direction: column;
    gap: 6px;
    align-items: center;
    justify-content: center;

    svg {
      font-size: 24px;
      color: #808080;
    }
  }

  /* Hide scrollbar for Chrome, Safari and Opera */
  ::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
`;

export const ListItem = styled.div`
  padding: 16px;
  margin-bottom: 1px;
  background-color: #161719;
  display: flex;
  align-items: center;
  gap: 12px;
  @media screen and (max-width: 350px) {
    padding: 6px;
    grid: 6px;
  }
  border-top: 1px solid #212224;
`;

export const DataWrapper = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  gap: 5px;
`;

export const ItemImage = styled.img.attrs({
  alt: "img",
})`
  width: 55px;
  height: 55px;
  border-radius: 8px;
  object-fit: cover;

  @media screen and (max-width: 350px) {
    width: 38px;
    height: 38px;
  }
`;

export const InfoWrapper = styled.div`
  flex: 1;
  display: flex;
  width: 100%;

  > :nth-child(1) {
    flex: 1;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  /* grid-gap: 8px; */
`;

export const ItemText = styled.div`
  font-size: 14px;
  font-style: normal;
  font-weight: 200;
  line-height: 1.5;
  text-transform: capitalize;
  color: #ffb829;

  @media screen and (max-width: 400px) {
    font-size: 13px;
  }

  @media screen and (max-width: 300px) {
    font-size: 12px;
  }
`;

export const DateText = styled.div`
  font-size: 12px;
  font-style: normal;
  font-weight: 200;
  line-height: 1.5;
  color: #686b6e;

  @media screen and (max-width: 300px) {
    font-size: 11px;
  }
`;

export const AmountText = styled.div`
  white-space: nowrap;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  color: #f9f9f9;

  @media screen and (max-width: 400px) {
    font-size: 13px;
  }

  @media screen and (max-width: 300px) {
    font-size: 12px;
  }
`;

export const StatusText = styled.div`
  height: 100%;
  white-space: nowrap;
  font-size: 10px;
  font-style: normal;
  font-weight: 600;
  line-height: 1.5;
  text-transform: capitalize;
  color: #f9f9f9;
  background-color: ${(props) =>
    props.status === REQUESTED_SK
      ? "#CC9321"
      : props.status === REJECTED_SK
      ? "#BE0B0B"
      : "#1F960C"};
  border-radius: 27px;
  padding: 0 8px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media screen and (max-width: 300px) {
    font-size: 11px;
  }
`;

export const BonusStatusText = styled(StatusText)`
  text-transform: none;
  width: auto;
  color: #f9f9f9;
  background-color: ${(props) =>
    props.status === "Used" ? "#BE0B0B" : "#1F960C"};
`;

export const ImageWrapper = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #f4f1eb;
`;

export const LogoImage = styled.img.attrs({
  alt: "img",
  src: BONUS_IMG,
})`
  width: 21px;
  border-radius: 50%;
  object-fit: contain;
  align-self: center;
`;

export const Image = styled.img.attrs({
  alt: "img",
})`
  width: 40px;
  border-radius: ${(props) => (props.radius === "none" ? "none" : "50%")};
  object-fit: contain;
  align-self: center;
`;

export const ExpiredLabel = styled.span`
  white-space: nowrap;
  color: #be0b0b;
  font-size: 12px;
  font-style: normal;
  font-weight: 200;
  line-height: 1.5;

  @media screen and (max-width: 365px) {
    font-size: 11px;
  }
`;

export const ExpiredText = styled(ExpiredLabel)`
  color: #808080;
`;

export const BalanceContainer = styled.div`
  background: #161719;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: auto 16px;
  border-radius: 8px;
`;

export const WalletImage = styled.img.attrs({
  alt: "Wallet",
  src: IMG_Wallet,
})`
  width: 95px;
  height: 100px;
`;

export const TotalBalanceContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  margin-left: 10px;
`;

export const TotalBalanceTitle = styled.div`
  font-weight: 200;
  font-size: 10px;
  color: #ffb829;
`;

export const TotalBalanceText = styled.div`
  font-weight: 600;
  font-size: 18px;
  color: #ffffff;
  margin: 3px 0px;
`;

export const SubContainer = styled.div`
  display: flex;
  align-items: baseline;
  width: 100%;
  margin-top: 3px;
`;

export const SubTitle = styled.div`
  font-weight: 200;
  font-size: 10px;
  color: #cfcfd1;
  margin-left: 3px;
  min-width: 105px;

  @media screen and (max-width: 320px) {
    min-width: 95px;
    font-size: 9px;
  }
  @media screen and (max-width: 303px) {
    min-width: 90px;
    font-size: 8px;
  }
`;

export const SubBalance = styled.div`
  font-wieght: 200;
  font-size: 10px;
  color: #9f9fa2;
  text-align: right;
  @media screen and (max-width: 320px) {
    font-size: 9px;
  }
  @media screen and (max-width: 303px) {
    font-size: 8px;
  }
`;

export const TitleWrapper = styled.div`
  display: flex;
  margin: 20px 16px 16px 16px;
`;

export const Title = styled.div`
  flex: 1;
  font-size: 16px;
  font-weight: 200;
  color: #f9f9f9;
`;

export const LinkText = styled.div`
  font-size: 14px;
  font-weight: normal;
  color: #ffb829;
  cursor: pointer;
`;
